import {createApp} from 'vue';
/**============================================================
*   [form] agree-checkbox
*   description : チェックボックス後ボタンの活性・非活性を変更する処理を記述
============================================================*/
document.addEventListener('DOMContentLoaded', function() {
  if(document.getElementById('js-agree')){
    const policyCheck = createApp({
      data() {
        return {
          isChecked: false,
        }
      }
    })
    policyCheck.mount('#js-agree');
  }
})
